import { get } from '@/helpers/apiRequest';

export default {
  data() {
    return {
      items: [],
      loading: false,
      paginator: {},
    };
  },

  beforeMount() { this.load(); },

  methods: {
    load(page = 1) {
      this.loading = true;
      const params = this.buildListagemParams(page);
      get(`${this.listagemEndpoint}?${params}`)
        .then(json => {
          this.items = json.itens || json.data || json;
          if (json.paginator) this.paginator = json.paginator;
        })
        .finally(() => { this.loading = false; });
    },

    buildListagemParams(page) {
      const params = new URLSearchParams({ page, sortBy: this.sort.by, sortType: this.sort.dir });
      this.appendFiltros(params);
      return params;
    },

    // Filtros padrão. Sobrescreva no componente para adicionar (ativo, codigo, etc).
    appendFiltros(params) {
      if (this.filtros.fabricanteId) params.append('fabricante_id', this.filtros.fabricanteId);
      if (this.filtros.termo) params.append('q', this.filtros.termo);
    },

    sortBy(column) {
      if (this.sort.by === column) {
        this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.by = column;
        this.sort.dir = 'asc';
      }
      this.load(1);
    },
  },
};
